import React, { useState, useEffect } from 'react';
import { useUserContext } from '../context/user_context';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom';



const Followers = ({ groups, subscribers, premium }) => {
  console.log('Followers');
  console.log(groups);
  console.log(premium);

  const history = useHistory();
  const { user } = useUserContext();
  const [membershipId, setMembershipId] = useState('');
  console.log(user);
  useEffect(() => {
    if (user.results.userAccounts && user.results.userAccounts.length > 0) {

      const membership = user.results.userAccounts[0];
     
      setMembershipId(membership.parent_membership_id);
    }
  }, [user]);
  // const handleAddCompanySubcriber = (membershipId) => {
  //   history.push(`/addcompanysubscriber/${membershipId}`);
  // };
  const handleMultiStepSubscriber = (membershipId) => {
    history.push(`/addcompanymultisubscriber/${membershipId}`);
  };
  const handleStartGroup = () => {
    // Add your logic here for what happens when the button is clicked
    history.push('/startagroup');
    // You can perform navigation or other actions here.
  };
  const avatars = [
    {
      img: 'https://pixinvent.com/materialize-material-design-admin-template/app-assets/images/user/12.jpg',
      html_url: 'https://google.com',
      alt: 'User 1',
      login: 'mani',
      phoneNumber: '9943',

    },
    {
      img: 'https://htmlstream.com/preview/unify-v2.6.2/assets/img-temp/400x450/img5.jpg',
      html_url: 'https://google.com',
      alt: 'User 2',
      login: 'mani',
      phoneNumber: '9943',
    },]
  const earnedPremiumValue = premium.length > 0 ? premium[0].earnedpremium : null;
  return (
    <Wrapper>
      <header>
        <div className='groupscount'>
          <div className="circle">
            <p> {groups.length}</p> {/* Display the count */}
            <button className='add-circle-button' onClick={handleStartGroup}>+</button>
          </div>
          <p>Groups</p>
        </div>
        <div className='duecount'>
          <div className="circle red" style={{ color: "#fff" }}>

            <p> <Link to={{ pathname: '/subscribers', state: { subscribers } }}>
              {subscribers.length}
            </Link></p>
            <button className='add-circle-button' onClick={() => handleMultiStepSubscriber(membershipId)}>+</button>
          </div>
          <p>Subscribers</p>
        </div>
        <div className='duecount'>
          <div className="circle red" style={{ color: "#fff" }}>
            {earnedPremiumValue !== null ? (
              <p>{earnedPremiumValue}</p>
            ) : (
              <p>0</p>
            )}
            <button className='add-circle-button' >+</button>

          </div>
          <p>Profit Earned</p>
        </div>
        {/* <div className='more'>
          <div className="circle red" style={{color:"#fff"}}>

          </div>
          <p>More</p>
        </div> */}


      </header>
      <button class="start-group-button" onClick={handleStartGroup}>
        Start a group
        {/*  <img src="victory-cup-image.png" alt="Victory Cup" /> */}
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.article`
display: flex;
flex-direction: column;
align-items:center;

background: var(--clr-white);
padding: 1.5rem 2rem;
border-top-right-radius: var(--radius);
border-bottom-left-radius: var(--radius);
border-bottom-right-radius: var(--radius);
position: relative;
&::before {
  content: 'Highlights';
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  background: var(--clr-white);
  color: var(--clr-grey-5);
  border-top-right-radius: var(--radius);
  border-top-left-radius: var(--radius);
  text-transform: capitalize;
  padding: 0.5rem 1rem 0 1rem;
  letter-spacing: var(--spacing);
  font-size: 1rem;
}

header {
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  justify-content: left;
  column-gap: 1rem;
  row-gap: 2px;
  margin-bottom: 3rem;
  
 
  h4 {
    margin-bottom: 0.25rem;
  }
  p {
    margin-bottom: 0;
  }
      
 }
 .circle {
  width: 6rem;
  height:6rem;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  // margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
} 
.groupscount {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
color:black;
}
.duecount {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
color:#fff;
}
.more {
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
}
gotoauction {
display: flex;
flex-direction: column;
align-items: left;
}

.label {
flex: 1; /* Distribute the available space equally among the labels */
text-align: left; /* Center-align the text within each label */

}
.buttonStyle {
border-radius: 5px;
background-color:#cd3240;
border: 2px solid transparent;
color: var(--clr-white); 
width: 270px;
padding-top: 8px;
margin-top:20px;
align-items: center;
cursor:pointer;
};
.start-group-button {
  background-color: var(--clr-red-dark);
  color: #fff; /* Button text color */
  border: none;
  border-radius: 10px;
  padding: 10px 50px;
  width:200px;
  margin: 10px 60px; /* Adjust the margin as needed */
  cursor: pointer;
  display: flex;
  align-items: center;
};
.add-circle-button {
  margin-left:0.5rem;
  margin-top:0.5rem;
  background: transparent;
  border-color: transparent;
  width: 30px;
  height:30px;
  background: var(--clr-red-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--clr-white);
  cursor: pointer;  
  margin-bottom: 2px;
  }
  /* Media query for screens with a maximum width of 768px (adjust as needed) */
@media (max-width: 768px) {
  .add-circle-button {
    width: 30px; /* Adjust the size for mobile view */
    height: 30px;
    background:green;
  }

`;
export default Followers;
